export default __webpack_public_path__ + "static/media/480_dummy2016-coach01-de.61f4289b.png";